import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFolder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10.305 4.869h4.067c.395 0 .735 0 1.014.022.295.023.588.075.87.215.42.21.767.544.985.962.147.282.201.574.226.865.023.275.023.609.023.993v5.607c0 .384 0 .718-.023.993a2.2 2.2 0 0 1-.226.865 2.23 2.23 0 0 1-.986.962c-.281.14-.574.192-.868.215-.28.023-.619.023-1.013.023H5.626c-.395 0-.734 0-1.014-.023a2.3 2.3 0 0 1-.868-.215 2.23 2.23 0 0 1-.985-.963 2.2 2.2 0 0 1-.226-.864c-.023-.275-.023-.608-.023-.992V5.619c0-1.239 1.024-2.21 2.248-2.21H7.57c.306-.001.573-.001.832.06.228.053.446.141.646.26l.592 1.107m.664.033-.577-.563-.044-.043c-.215-.21-.406-.396-.635-.533l.592 1.106M4.01 6.369v7.135c0 .422 0 .692.017.897.016.195.044.264.06.295a.73.73 0 0 0 .323.314c.039.02.116.047.32.063.213.017.493.018.923.018h8.692c.43 0 .71 0 .922-.018.204-.016.281-.044.32-.063a.73.73 0 0 0 .324-.314c.016-.031.044-.1.06-.295.017-.205.018-.475.018-.897v-5.55c0-.42 0-.69-.018-.896-.016-.195-.044-.264-.06-.295a.73.73 0 0 0-.324-.314c-.039-.019-.116-.047-.32-.063a13 13 0 0 0-.925-.017z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFolder;
